/* WeeDo cart upgrade: add-to-cart for the "Complete the kit" rows inside the cart drawer.
   On the cart page the forms post normally and return to /cart. */
(function () {
  if (window.__weedoCartAddons) return;
  window.__weedoCartAddons = true;

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest && event.target.closest('form[data-weedo-addon="drawer"]');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // fall back to a normal post

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const oldError = form.parentElement.querySelector('.weedo-addon__error');
    if (oldError) oldError.remove();
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    const body = new FormData(form);
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body,
      });
      const data = await response.json();
      if (data.status) {
        const msg = document.createElement('p');
        msg.className = 'weedo-addon__error';
        msg.setAttribute('role', 'alert');
        msg.textContent = data.description || data.message || 'That size just sold out.';
        form.insertAdjacentElement('afterend', msg);
        if (button) {
          button.disabled = false;
          button.textContent = 'Add';
        }
        return;
      }
      drawer.renderContents(data);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'weedo-addon', productVariantId: body.get('id'), cartData: data });
      }
    } catch (e) {
      form.removeAttribute('data-weedo-addon');
      form.submit();
    }
  });
})();
